module.exports = __webpack_public_path__ + "static/media/Money_font_awesome.3e1f8f5a.svg";